module.exports = __webpack_public_path__ + "static/media/8.648e09d2.jpg";